import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import './Payment.css';

const Payment: React.FC = () => {
  const { settings } = useSiteSettings();
  return (
    <div className="payment">
      <section className="section">
        <div className="container">
          <h2>Payment</h2>

          <div className="payment-block">
            <h3>Payment Types Accepted</h3>
            <ul className="payment-list">
              <li>Cash</li>
              <li>Credit Card (Limit {settings.creditCardLimit})</li>
              <li>Bank Draft (Canadian or US Bank Only). All cheques made out to EuroJDM Auto Inc.</li>
              <li>Wire Transfer</li>
              <li>Interac eTransfer (Send funds to eurojdmauto@gmail.com)</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Wire Transfer */}
      <section className="section wire-section">
        <div className="container">
          <div className="wire-grid">
            <div className="wire-card">
              <h3>Wire Transfer Instructions (CAD Funds)</h3>
              <div className="wire-rows">
                <div className="wire-row"><span>Routing Number</span><span>CC000300144</span></div>
                <div className="wire-row"><span>Bank Account Holder</span><span>EuroJDM Auto Inc.</span></div>
                <div className="wire-row"><span>Account Holder Address</span><span>104-6295B Mississauga Rd, Mississauga, ON L5N 1A5</span></div>
                <div className="wire-row"><span>Contact Name</span><span>Elvis John</span></div>
                <div className="wire-row"><span>Account Phone</span><span>6473671603</span></div>
                <div className="wire-row"><span>Bank Name</span><span>RBC (Royal Bank of Canada)</span></div>
                <div className="wire-row"><span>Bank Address</span><span>2955 Hazelton Place, Mississauga, ON, L5M 6J3</span></div>
                <div className="wire-row"><span>Transit Number (Branch Number)</span><span>Contact us</span></div>
                <div className="wire-row"><span>Institution Number</span><span>003</span></div>
                <div className="wire-row"><span>Account Number</span><span>Contact us</span></div>
                <div className="wire-row"><span>RBC Swift BIC</span><span>ROYCCAT2</span></div>
              </div>
            </div>

            <div className="wire-card">
              <h3>Wire Transfer Instructions (USD Funds)</h3>
              <div className="wire-rows">
                <div className="wire-row"><span>Account Name</span><span>EuroJDM Auto Inc.</span></div>
                <div className="wire-row"><span>Business Address</span><span>104-6295B Mississauga Rd. Mississauga, ON L5N 1A5</span></div>
                <div className="wire-row"><span>Bank</span><span>Royal Bank of Canada (RBC)</span></div>
                <div className="wire-row"><span>Bank Address</span><span>2955 Hazelton Pl, Mississauga, ON L5M 6J3</span></div>
                <div className="wire-row"><span>USD Account Number</span><span>Contact us</span></div>
                <div className="wire-row"><span>Bank Swift Code</span><span>ROYCCAT2</span></div>
              </div>
              <div className="wire-extra">
                <p>Wire payments sent in USD from the US are paid through JP Morgan Chase Bank, New York, NY USA and require the following additional information:</p>
                <div className="wire-rows">
                  <div className="wire-row"><span>JP Morgan Chase Bank SWIFT BIC</span><span>CHASUS33</span></div>
                  <div className="wire-row"><span>Fedwire ABA Routing Number</span><span>0212000021</span></div>
                  <div className="wire-row"><span>CHIPS UID</span><span>055253</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Payment;
